export default __webpack_public_path__ + "static/media/MassimoGiovanozzi.895c2339.png";